import type { DecodedAudioData } from "../types";


function getAudioContextConstructor(): typeof AudioContext {
  const constructor = window.AudioContext ?? window.webkitAudioContext;
  if (!constructor) {
    throw new Error("This browser does not expose the Web Audio API needed for local decode.");
  }
  return constructor;
}

export async function decodeAudioFile(file: File): Promise<DecodedAudioData> {
  const bytes = await file.arrayBuffer();
  const AudioContextConstructor = getAudioContextConstructor();
  const context = new AudioContextConstructor();

  try {
    await context.resume();
    const buffer = await context.decodeAudioData(bytes.slice(0));
    if (buffer.numberOfChannels === 0 || buffer.duration <= 0) {
      throw new Error("音声トラックが見つかりませんでした。");
    }
    const channelData: Float32Array[] = [];

    for (let channelIndex = 0; channelIndex < buffer.numberOfChannels; channelIndex += 1) {
      channelData.push(new Float32Array(buffer.getChannelData(channelIndex)));
    }

    return {
      sampleRate: buffer.sampleRate,
      channelData,
      durationSec: buffer.duration,
    };
  } catch (error) {
    const detail = error instanceof Error ? error.message : String(error);
    throw new Error(`このブラウザで対応している音声または動画形式か確認してください。${detail}`);
  } finally {
    void context.close();
  }
}
